import * as React from 'react'

type Scalar = boolean | number | string | bigint | null | undefined

export function useMemo<T>(factory: () => T, deps: Scalar[]) {
  return React.useMemo(factory, deps) // eslint-disable-line react-hooks/exhaustive-deps
}

export function useUnsafeMemo<T>(factory: () => T, deps?: React.DependencyList | undefined) {
  return React.useMemo(factory, deps ?? []) // eslint-disable-line react-hooks/exhaustive-deps
}
